// extracted by mini-css-extract-plugin
module.exports = {"title":"Advantages_title__2eFcS","button_container":"Advantages_button_container__1IPzx","button":"Advantages_button__SR_M-","button_wrapper":"Advantages_button_wrapper__3stcF"};